import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import SplashScreen from 'components/SplashScreen/SplashScreen';
import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import router from 'routes';

const App: React.FC = () => {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    console.log(
      '%cStop ! \nHo aiza iny eeee ?!',
      'color: red; font-size: 50px; font-weight: bold;',
    );
    console.log(
      "%cIl s'agit d'une fonctionnalité de navigateur conçue pour les développeurs. ",
      'font-size: 24px; color: white;',
    );
  }, []);

  const handleSplashComplete = (_isAuthenticated: boolean) => {
    setShowSplash(false);
  };

  return (
    <ErrorBoundary>
      <div style={{ minWidth: '300px' }} translate='no'>
        {showSplash ? (
          <SplashScreen onComplete={handleSplashComplete} />
        ) : (
          <RouterProvider router={router} />
        )}
      </div>
    </ErrorBoundary>
  );
};

export default App;
